export function LogoMark({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-label="Zork Media logo">
      <path d="M6 9h34L20 29h22" stroke="#E6FF00" strokeWidth="6" strokeLinecap="square" />
      <path d="M6 39h24" stroke="#F8FAFC" strokeWidth="6" strokeLinecap="square" />
      <circle cx="41" cy="39" r="4" fill="#E6FF00" />
    </svg>
  );
}

export function Logo({ size = 36, withWordmark = true }) {
  return (
    <span className="inline-flex items-center gap-3" data-testid="nav-logo">
      <LogoMark size={size} />
      {withWordmark && (
        <span className="font-display font-extrabold tracking-tight text-lg leading-none">
          ZORK<span className="text-volt">/</span>MEDIA
        </span>
      )}
    </span>
  );
}
